// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23TkG","importantInfo":"styles_importantInfo__2bp9d"};